import type { FaireProductEntity } from "../../entity_types/product";

export const p_6ybt2frtty: FaireProductEntity = {
  token: "p_6ybt2frtty",
  type: "product",
  name: "Lymphatic Roller, 10mL -3pack",
  brandToken: "b_zqh3u776ct",
  brandName: "Evergreen Apothecary",
  imageUrl:
    "https://cdn.faire.com/fastly/f8268f1d9195a15603d90da1da6a05cb83829e21bdb6d7f8374ecb6201add39d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6120ecc9b88167f1a99ea666229b4cddd8e64ffc0addaca2deee55c20e7ddcb8.jpeg",
    "https://cdn.faire.com/fastly/5fe8a8e0bbcae3b9af4b8ee74a172a0ff31eba0479905e79c0f8c21c0c880c1e.jpeg",
  ],
  priceDollars: 27,
  description:
    "Harness the power of lymphatic drainage with our Lymphatic Roller, formulated with the same potent blend as our Eris Cream. Apply to areas of inflammation and massage toward lymph nodes to support natural detoxification and reduce fluid buildup. Perfect for pre-workout application to enhance your body's cleansing processes. The convenient 10mL roller bottle design makes it ideal for travel and on-the-go use—simply toss it in your bag for anytime access. \nComes in a case of 3. \n\nOut of stock? Feel free to message us!\nLooking for white label? Message us and we are happy to work with you.",
  tags: [],
  msrpDollars: 54,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:06.687Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
